/**
 * Mauvely's own conversation with an account: relay-server `docs/official.md`.
 *
 * **The badge is earned twice.** The conversation must carry the server's
 * `official` flag, and the message must be stamped by the server with the
 * sender `mauvely`. Anybody can name a group "Mauvely", set their own name to
 * it, or put it in a payload's `n`; nobody can set the flag or the stamp.
 */

/** The synthetic sender of every official message. No account holds it. */
export const OFFICIAL_SENDER = 'mauvely';

export const isOfficialMessage = (official: boolean | undefined, senderId: string): boolean =>
  official === true && senderId === OFFICIAL_SENDER;
